var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"ml-4"},[_vm._v("Ubah Profile Pengguna")]),_c('FChangeProfile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }